export { default } from "./EditDoctorAvailability";
